import React, { Fragment } from 'react';
import ReduxToastr from 'react-redux-toastr';
import AppRoutes from './routes';
import 'rsuite/dist/styles/rsuite-default.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css'; // eslint-disable-line import/no-extraneous-dependencies
import './App.css';

const App = () => (
  <Fragment>
    <AppRoutes />
    <ReduxToastr position="top-center" timeOut={5000} newestOnTop={false} />
  </Fragment>
);

export default App;
